export const POST_NEW_TRIAL_USER = "/demo/register";
// Get new trial user information. (Name, email, etc)
export const GET_NEW_TRIAL_USER = "/demo/register";
// Update a specific prospective sell.
export const UPDATE_NEW_TRIAL_USER = "/demo/register";
//Delete Data
export const DELETE_NEW_TRIAL_USER = "/demo/register";
// Send a trial email for self registration.
export const SEND_NEW_TRIAL_USER_EMAIL = "/internal/createtriallink";
//Login
export const POST_LOGIN = "/login";

export const ADD_COGNITO_USER = "/signup";

export const POST_FORGET_PASSWORD = "/forgotpassword";

export const POST_RESET_FORGOT_PASSWORD = "/confirmforgotpassword";

export const GET_NEW_COGNITO_USER = "/user";

export const COGNITO_USER = "/user";